<vs-app-page
  [config]="{
    title: 'Reports',
    icon: 'table',

    showDivider: true,
    description: 'This is an overview of all reports that can be downloaded'
  }"
>
  <vs-breadcrumbs slot="breadcrumbs" [config]="{ items: [{ label: 'Reports' }] }"></vs-breadcrumbs>

  <div class="flex flex-wrap gap-3">
    <ng-container *ngIf="canViewReports$ | async">
      <vs-card
        class="h-64 !w-64 shrink-0 border-1 hover:border-primary-300 ring-primary-100 hover:ring-2 transition-all cursor-pointer"
        (click)="productionReportDialog.open()"
      >
        <vs-card-content class="h-full">
          <div class="flex flex-col justify-between h-full">
            <vs-empty-state
              class="flex justify-center items-center self-center mt-3 h-24 max-w-[60%]"
              [config]="{ imgsrc: 'blank-documents' }"
            ></vs-empty-state>
            <div class="flex flex-col">
              <p class="text-lg font-medium text-gray-900">Production</p>
              <p class="text-xs font-normal text-gray-900">
                A contract-level detail of product sold, including date of sale, retail price, and payments made.
              </p>
            </div>
          </div>
        </vs-card-content>
      </vs-card>

      <vs-dialog #productionReportDialog (closed)="productionStartMenuTrigger.close();productionEndMenuTrigger.close()">
        <vs-dialog-header
          [config]="{
          mode: 'simple',
          hideCloseButton: false,
          icon: 'download-01',
          iconTheme: 'primary',
          title: 'Download Production report',
          subtitle: 'Configure the following settings to download your report.'
        }"
        >
        </vs-dialog-header>

        <div class="gap-2 justify-between my-4 mx-2">
          <p class="text-sm font-medium text-gray-700 self-center">Activity period</p>
          <div class="flex gap-x-2 my-2">
            <p class="text-sm font-medium text-gray-700 self-center">From</p>
            <input
              #productionStartMenuTrigger="vsMenuTriggerFor"
              vsInput
              type="text"
              class="max-w-[50%]"
              [value]="productionStartDate$.value | date"
              placeholder="Start date"
              [vsMenuTriggerFor]="productionStartMenu"
            />
            <p class="text-sm font-medium text-gray-700 self-center">To</p>
            <input
              #productionEndMenuTrigger="vsMenuTriggerFor"
              vsInput
              type="text"
              class="max-w-[50%]"
              [value]="productionEndDate$.value | date"
              placeholder="End date"
              [vsMenuTriggerFor]="productionEndMenu"
            />
          </div>
          <ng-template #productionStartMenu>
            <vs-card class="mt-10">
              <vs-date-picker
                [value]="productionStartDate$.value"
                (selectionChanged)="productionStartDate$.next($any($event));productionStartMenuTrigger.close()"
              ></vs-date-picker>
            </vs-card>
          </ng-template>
          <ng-template #productionEndMenu>
            <vs-card class="mt-10">
              <vs-date-picker
                [value]="productionEndDate$.value"
                (selectionChanged)="productionEndDate$.next($any($event));productionEndMenuTrigger.close()"
              ></vs-date-picker>
            </vs-card>
          </ng-template>
        </div>

        <div slot="buttons" class="flex gap-2 w-full">
          <button vs-button class="flex-grow" appearance="outline" (click)="productionReportDialog.close()">
            Cancel
          </button>
          <a
            vs-button
            class="flex-grow"
            theme="primary"
            [href]="productionExportUrl$ | async"
            [class.pointer-events-none]="(productionExportUrl$ | async) === null"
            [attr.aria-disabled]="(productionExportUrl$ | async) === null"
            (click)="productionReportDialog.close()"
          >
            Download CSV
          </a>
        </div>
      </vs-dialog>

      <ng-container *ngIf="exportUrl$ | async as exportUrl">
        <vs-card
          class="h-64 !w-64 shrink-0 border-1 hover:border-primary-300 ring-primary-100 hover:ring-2 transition-all cursor-pointer"
          (click)="remittanceReportDialog.open()"
        >
          <vs-card-content class="h-full">
            <div class="flex flex-col justify-between h-full">
              <vs-empty-state
                class="flex justify-center items-center self-center mt-3 h-24 max-w-[60%]"
                [config]="{
              imgsrc: 'blank-documents'
            }"
              ></vs-empty-state>
              <div class="flex flex-col">
                <p class="text-lg font-medium text-gray-900">Remittance Report</p>
                <p class="text-xs font-normal text-gray-900">
                  Review the details of all warranties provisioned and the allocation of their fees to determine how
                  much must be remitted to the insurer.
                </p>
              </div>
            </div>
          </vs-card-content>
        </vs-card>

        <vs-dialog #remittanceReportDialog (closed)="startMenuTrigger.close();endMenuTrigger.close()">
          <vs-dialog-header
            [config]="{
            mode: 'simple',
            hideCloseButton: false,
            
            icon: 'download-01',
            iconTheme: 'primary',

            title: 'Download \'Remittance Report\'',
            subtitle: 'Configure the following settings to download your report.' 
          }"
          >
          </vs-dialog-header>

          <div class="gap-2 justify-between my-4 mx-2">
            <p class="text-sm font-medium text-gray-700 self-center">Review all warranties</p>
            <div class="flex gap-x-2 my-2">
              <p class="text-sm font-medium text-gray-700 self-center">From</p>

              <input
                #startMenuTrigger="vsMenuTriggerFor"
                vsInput
                type="text"
                class="max-w-[50%]"
                [value]="startDate$.value |date"
                [vsMenuTriggerFor]="startDateMenu"
              />
              <p class="text-sm font-medium text-gray-700 self-center">To</p>
              <input
                #endMenuTrigger="vsMenuTriggerFor"
                vsInput
                type="text"
                class="max-w-[50%]"
                [value]="endDate$.value | date"
                [vsMenuTriggerFor]="endDateMenu"
              />
            </div>
            <ng-template #startDateMenu>
              <vs-card class="mt-10">
                <vs-date-picker
                  [value]="startDate$.value"
                  (selectionChanged)="startDate$.next($any($event));startMenuTrigger.close()"
                ></vs-date-picker>
              </vs-card>
            </ng-template>

            <ng-template #endDateMenu>
              <vs-card class="mt-10">
                <vs-date-picker
                  [value]="endDate$.value"
                  (selectionChanged)="endDate$.next($any($event));endMenuTrigger.close()"
                ></vs-date-picker>
              </vs-card>
            </ng-template>
          </div>

          <div slot="buttons" class="flex gap-2 w-full">
            <button vs-button class="flex-grow" appearance="outline" (click)="remittanceReportDialog.close()">
              Cancel
            </button>
            <a vs-button class="flex-grow" theme="primary" [href]="exportUrl" (click)="remittanceReportDialog.close()">
              Download
            </a>
          </div>
        </vs-dialog>
      </ng-container>

      <vs-card
        class="h-64 !w-64 shrink-0 border-1 hover:border-primary-300 ring-primary-100 hover:ring-2 transition-all cursor-pointer"
        (click)="distributorListDialog.open()"
      >
        <vs-card-content class="h-full">
          <div class="flex flex-col justify-between h-full">
            <vs-empty-state
              class="flex justify-center items-center self-center mt-3 h-24 max-w-[60%]"
              [config]="{ imgsrc: 'blank-documents' }"
            ></vs-empty-state>
            <div class="flex flex-col">
              <p class="text-lg font-medium text-gray-900">Distributor List</p>
              <p class="text-xs font-normal text-gray-900">
                A contact list of your distributors, including email addresses, for communicating rate changes, new
                plans, and other updates.
              </p>
            </div>
          </div>
        </vs-card-content>
      </vs-card>

      <vs-dialog
        #distributorListDialog
        (closed)="distributorListStartMenuTrigger.close();distributorListEndMenuTrigger.close()"
      >
        <vs-dialog-header
          [config]="{
          mode: 'simple',
          hideCloseButton: false,
          icon: 'download-01',
          iconTheme: 'primary',
          title: 'Download Distributor List',
          subtitle: 'Configure the following settings to download your report.'
        }"
        >
        </vs-dialog-header>

        <div class="gap-2 justify-between my-4 mx-2">
          <p class="text-sm font-medium text-gray-700 self-center">Date created</p>
          <div class="flex gap-x-2 my-2">
            <p class="text-sm font-medium text-gray-700 self-center">From</p>
            <input
              #distributorListStartMenuTrigger="vsMenuTriggerFor"
              vsInput
              type="text"
              readonly
              class="max-w-[50%]"
              [value]="distributorListStartDate$.value | date"
              placeholder="Start date"
              [vsMenuTriggerFor]="distributorListStartMenu"
            />
            <p class="text-sm font-medium text-gray-700 self-center">To</p>
            <input
              #distributorListEndMenuTrigger="vsMenuTriggerFor"
              vsInput
              type="text"
              readonly
              class="max-w-[50%]"
              [value]="distributorListEndDate$.value | date"
              placeholder="End date"
              [vsMenuTriggerFor]="distributorListEndMenu"
            />
          </div>
          <p class="text-xs font-normal text-gray-500">Leave both dates empty to download all distributors.</p>
          <ng-template #distributorListStartMenu>
            <vs-card class="mt-10">
              <vs-date-picker
                [value]="distributorListStartDate$.value"
                (selectionChanged)="distributorListStartDate$.next($any($event));distributorListStartMenuTrigger.close()"
              ></vs-date-picker>
            </vs-card>
          </ng-template>
          <ng-template #distributorListEndMenu>
            <vs-card class="mt-10">
              <vs-date-picker
                [value]="distributorListEndDate$.value"
                (selectionChanged)="distributorListEndDate$.next($any($event));distributorListEndMenuTrigger.close()"
              ></vs-date-picker>
            </vs-card>
          </ng-template>
        </div>

        <div slot="buttons" class="flex gap-2 w-full">
          <button vs-button class="flex-grow" appearance="outline" (click)="distributorListDialog.close()">
            Cancel
          </button>
          <a
            vs-button
            class="flex-grow"
            theme="primary"
            [href]="distributorListExportUrl$ | async"
            [class.pointer-events-none]="(distributorListExportUrl$ | async) === null"
            [attr.aria-disabled]="(distributorListExportUrl$ | async) === null"
            (click)="distributorListDialog.close()"
          >
            Download Excel
          </a>
        </div>
      </vs-dialog>

      <vs-card
        class="h-64 !w-64 shrink-0 border-1 hover:border-primary-300 ring-primary-100 hover:ring-2 transition-all cursor-pointer"
        (click)="customerListDialog.open()"
      >
        <vs-card-content class="h-full">
          <div class="flex flex-col justify-between h-full">
            <vs-empty-state
              class="flex justify-center items-center self-center mt-3 h-24 max-w-[60%]"
              [config]="{ imgsrc: 'blank-documents' }"
            ></vs-empty-state>
            <div class="flex flex-col">
              <p class="text-lg font-medium text-gray-900">Customer List</p>
              <p class="text-xs font-normal text-gray-900">
                A contact list of your customers, including email addresses, for communicating rate changes, new plans,
                and other updates.
              </p>
            </div>
          </div>
        </vs-card-content>
      </vs-card>

      <vs-dialog #customerListDialog (closed)="customerListStartMenuTrigger.close();customerListEndMenuTrigger.close()">
        <vs-dialog-header
          [config]="{
          mode: 'simple',
          hideCloseButton: false,
          icon: 'download-01',
          iconTheme: 'primary',
          title: 'Download Customer List',
          subtitle: 'Configure the following settings to download your report.'
        }"
        >
        </vs-dialog-header>

        <div class="gap-2 justify-between my-4 mx-2">
          <p class="text-sm font-medium text-gray-700 self-center">Date created</p>
          <div class="flex gap-x-2 my-2">
            <p class="text-sm font-medium text-gray-700 self-center">From</p>
            <input
              #customerListStartMenuTrigger="vsMenuTriggerFor"
              vsInput
              type="text"
              readonly
              class="max-w-[50%]"
              [value]="customerListStartDate$.value | date"
              placeholder="Start date"
              [vsMenuTriggerFor]="customerListStartMenu"
            />
            <p class="text-sm font-medium text-gray-700 self-center">To</p>
            <input
              #customerListEndMenuTrigger="vsMenuTriggerFor"
              vsInput
              type="text"
              readonly
              class="max-w-[50%]"
              [value]="customerListEndDate$.value | date"
              placeholder="End date"
              [vsMenuTriggerFor]="customerListEndMenu"
            />
          </div>
          <p class="text-xs font-normal text-gray-500">Leave both dates empty to download all customers.</p>
          <ng-template #customerListStartMenu>
            <vs-card class="mt-10">
              <vs-date-picker
                [value]="customerListStartDate$.value"
                (selectionChanged)="customerListStartDate$.next($any($event));customerListStartMenuTrigger.close()"
              ></vs-date-picker>
            </vs-card>
          </ng-template>
          <ng-template #customerListEndMenu>
            <vs-card class="mt-10">
              <vs-date-picker
                [value]="customerListEndDate$.value"
                (selectionChanged)="customerListEndDate$.next($any($event));customerListEndMenuTrigger.close()"
              ></vs-date-picker>
            </vs-card>
          </ng-template>
        </div>

        <div slot="buttons" class="flex gap-2 w-full">
          <button vs-button class="flex-grow" appearance="outline" (click)="customerListDialog.close()">Cancel</button>
          <a
            vs-button
            class="flex-grow"
            theme="primary"
            [href]="customerListExportUrl$ | async"
            [class.pointer-events-none]="(customerListExportUrl$ | async) === null"
            [attr.aria-disabled]="(customerListExportUrl$ | async) === null"
            (click)="customerListDialog.close()"
          >
            Download Excel
          </a>
        </div>
      </vs-dialog>
    </ng-container>

    <vs-card
      class="h-64 !w-64 shrink-0 border-1 hover:border-primary-300 ring-primary-100 hover:ring-2 transition-all cursor-pointer"
      (click)="router.navigate(['monthly-financials'], { relativeTo: route })"
    >
      <vs-card-content class="h-full">
        <div class="flex flex-col justify-between h-full">
          <vs-empty-state
            class="flex justify-center items-center self-center mt-3 h-24 max-w-[60%]"
            [config]="{ imgsrc: 'blank-documents' }"
          ></vs-empty-state>

          <div class="flex flex-col">
            <p class="text-lg font-medium text-gray-900">Monthly Financials</p>
            <p class="text-xs font-normal text-gray-900">
              Monthly financial reporting aggregated by policy & plan. Useful for generating invoices, or alternative
              reporting.
            </p>
          </div>
        </div>
      </vs-card-content>
    </vs-card>

    <vs-card
      *ngIf="canViewBfsFinancing$ | async"
      class="h-64 !w-64 shrink-0 border-1 hover:border-primary-300 ring-primary-100 hover:ring-2 transition-all cursor-pointer"
      (click)="router.navigate(['bfs-financing'], { relativeTo: route })"
    >
      <vs-card-content class="h-full">
        <div class="flex flex-col justify-between h-full">
          <vs-empty-state
            class="flex justify-center items-center self-center mt-3 h-24 max-w-[60%]"
            [config]="{ imgsrc: 'blank-documents' }"
          ></vs-empty-state>

          <div class="flex flex-col">
            <p class="text-lg font-medium text-gray-900">Budco Financial Services (BFS)</p>
            <p class="text-xs font-normal text-gray-900">
              Review financing attempts by status and payment type to find deals needing attention.
            </p>
          </div>
        </div>
      </vs-card-content>
    </vs-card>
  </div>
</vs-app-page>
